// Enum
export const Rules = Object.freeze({
  REQUIRED: 'required',
  EMAIL: 'email',
});

export class InputRule {
  constructor(callback) {
    this.callback = callback;
  }
  validate(value) {
    return this.callback(value);
  }
}

const rules = {
  [Rules.REQUIRED]: new InputRule((input) => Boolean(input.trim())),
  [Rules.EMAIL]: new InputRule((input) => {
    // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(input.trim());
  }),
};

class FormStateCommander {
  constructor(callback) {
    this.$dirty = false;
    this.$valid = false;
    this.$invalid = true;
    this.vueModel = null;
    this.callback = callback;
  }

  update() {
    this.vueModel.$forceUpdate();
  }

  setPristine() {
    this.$dirty = false;
    this.update();
  }

  setDirty() {
    this.$dirty = true;
    this.update();
  }

  setValidity(validity) {
    this.$invalid = !validity;
    this.$valid = validity;
    this.update();
  }

  setInvalid() {
    this.$invalid = true;
    this.$valid = false;
    this.update();
  }

  setValid() {
    this.$invalid = false;
    this.$valid = true;
    this.update();
  }
}

class FormInputsStateCommander extends FormStateCommander {
  constructor(callback) {
    super(callback);
    this.inputs = {};
  }

  valid(name) {
    return this.inputs[name].$valid;
  }
  invalid(name) {
    return this.inputs[name].$invalid;
  }

  clear(name) {
    const clear = this.inputs[name].$dirty && this.inputs[name].$valid;
    return clear;
  }

  dirty(name) {
    return this.inputs[name].$dirty;
  }
}

export class FormInput extends FormStateCommander {
  constructor(name, inputRules = []) {
    super();
    this.value = null;
    this.vueModel = null;
    this.prepareRules = [];
    this.name = name;
    this.rules = inputRules;
    this._prepareRules();
  }

  validate() {
    this.checkDirty();
    if (this.rules.length) {
      const validity = this.preparedRules.every((rule) => rule.validate(this.value));
      this.setValidity(validity);
      this.vueModel.$forceUpdate();
      return validity;
    }
    this.setValid();
    this.vueModel.$forceUpdate();
    return true;
  }

  setVueModel(model) {
    this.vueModel = model;
  }

  checkDirty() {
    if (this.value) {
      this.setDirty();
    } else {
      return;
    }
  }

  _prepareRules() {
    (this.rules).forEach((rule) => {
      if (rule instanceof InputRule) {
        this.preparedRules.push(rule);
      } else {
        this.preparedRules.push(this.tryToGetRuleByEnum(rule));
      }
    });
  }

    tryToGetRuleByEnum(rule) {    // eslint-disable-line
    if (!rules[rule]) {
      throw new Error('No such rule registered in module');
    } else {
      return rules[rule];
    }
  }
}

export class Form extends FormInputsStateCommander {
  /**
     * @param registeredInputs FormInput[]
     */
  constructor(registeredInputs, vueModel) {
    super();
    this.inputs = {};
    this.registeredInputs = registeredInputs;
    this.vueModel = vueModel;
    this.registerInputs();
  }

  validate(name) {
    this.setDirty();
    let validity = true;
    if (!name) {
      this.registeredInputs.forEach(input => {
        const result = input.validate();
        if (!result) {
          validity = false;
        }
      });
      validity = this.registeredInputs.every(input => input.validate());
    } else {
      validity = this.getInput(name).validate();
    }
    this.setValidity(validity);
    this.vueModel.$forceUpdate();
    return validity;
  }

  /**
     * @return FormInput
     */
  getInput(name) {
    return this.inputs[name];
  }

  registerInputs() {
    this.registeredInputs.forEach((input) => {
      input.setVueModel(this.vueModel);
      if (this.inputs[input.name]) {
        throw new Error('Such input name already registered in form');
      } else {
        this.inputs[input.name] = input;
      }
    });
  }
}
